import {FjdCollapsibleCard} from "@efast/fjd-react-components";
import {ReactNode} from "react";
import "./CollapsableCard.css"

export interface CollapsableCardProps {
    children: ReactNode | ReactNode[];
    header: String;

}

export const CollapsableCard = ({children, header}: CollapsableCardProps) => {
    return <FjdCollapsibleCard  heading={header} >
        {children}
    </FjdCollapsibleCard>
}

export default CollapsableCard;